import React, { useEffect } from 'react';

import { withScreenWidget } from '@gogame/screens';

import KPIDataChart from 'scenes/KPI/components/KPIDataChart';
import { kpiReducer } from 'scenes/KPI/reducers';

import KPIPresetsActions from './Actions';
import KPIPresetsDescription from './Description';
import KPIPresetStorage from './Storage';

export const KPIWidget = withScreenWidget({
  title: 'KPIs',
  name: 'kpi',
  reducer: kpiReducer,
  storage: <KPIPresetStorage />,
  description: <KPIPresetsDescription />,
  actions: <KPIPresetsActions />,
})(({ tooltipPosStrategy, collapsed }) => {
  // force render for correct draw chart and legend
  const [, setCollapsedState] = React.useState(collapsed);

  useEffect(() => {
    setCollapsedState(collapsed);
  }, [collapsed]);

  return (
    <KPIDataChart
      withPaper={false}
      tooltipPosStrategy={tooltipPosStrategy}
      style={{ height: '284px' }}
    />
  );
});

export default KPIWidget;
